import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SpinnerComponent } from './spinner.component';
import { SpinnerService } from "./spinner.service";

@NgModule({
    imports: [
        CommonModule
    ],
    declarations: [SpinnerComponent],
    exports: [
        SpinnerComponent
    ],
    providers: [
        SpinnerService,
    ]
})
export class SpinnerModule { }



// WEBPACK FOOTER //
// /Users/avihayev/Phone-Plans/Lading Page/landing-page-web/src/app/modules/spinner/spinner.module.ts